import { useEffect } from 'react';

export default function PrivacidadPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0C] pt-24 pb-16" data-testid="privacy-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <h1 className="text-3xl font-light tracking-tight text-zinc-100 mb-8 font-[Outfit]">
          Aviso de Privacidad
        </h1>
        <p className="text-xs text-zinc-500 mb-8">Última actualización: Abril 2026 | Conforme a la LFPDPPP de México</p>

        <div className="prose-legal space-y-8 text-sm text-zinc-400 leading-relaxed">
          <section>
            <h2 className="text-lg text-zinc-200 mb-3 font-medium">1. Responsable del tratamiento</h2>
            <p>MorphMX, con domicilio en México, es responsable del tratamiento de los datos personales que recabamos de nuestros usuarios conforme a la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP).</p>
          </section>

          <section>
            <h2 className="text-lg text-zinc-200 mb-3 font-medium">2. Datos personales recabados</h2>
            <p>Recabamos los siguientes datos personales:</p>
            <ul className="list-disc pl-5 space-y-1 mt-2">
              <li><strong className="text-zinc-300">Identificación:</strong> nombre, email, teléfono, ubicación.</li>
              <li><strong className="text-zinc-300">Financieros:</strong> datos de pago procesados por Stripe (no almacenamos datos de tarjeta).</li>
              <li><strong className="text-zinc-300">Documentos legales:</strong> facturas, certificados UMA/PIMVS, documentos CITES subidos voluntariamente.</li>
              <li><strong className="text-zinc-300">Técnicos:</strong> dirección IP, device fingerprint, cookies, datos de navegación.</li>
              <li><strong className="text-zinc-300">Transaccionales:</strong> historial de compras, ventas, pujas, reviews.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg text-zinc-200 mb-3 font-medium">3. Finalidades del tratamiento</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>Crear y administrar tu cuenta de usuario.</li>
              <li>Procesar transacciones y pagos.</li>
              <li>Verificar identidad y documentación legal.</li>
              <li>Prevención de fraude y detección de actividades sospechosas.</li>
              <li>Operación del sistema de reputación, strikes y badges.</li>
              <li>Cumplimiento de obligaciones legales y cooperación con autoridades.</li>
              <li>Mejora de nuestros servicios y personalización de la experiencia.</li>
              <li>Envío de notificaciones operativas (billing, expiración, strikes).</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg text-zinc-200 mb-3 font-medium">4. Datos sensibles</h2>
            <p>No recabamos datos personales sensibles. Los documentos legales subidos contienen información de carácter público-comercial.</p>
          </section>

          <section>
            <h2 className="text-lg text-zinc-200 mb-3 font-medium">5. Uso antifraude</h2>
            <p>Recopilamos y analizamos dirección IP, device fingerprint y patrones de comportamiento con el fin exclusivo de detectar y prevenir fraude, shill bidding y actividades ilegales. Estos datos se procesan de forma automatizada y se almacenan de forma segura.</p>
          </section>

          <section>
            <h2 className="text-lg text-zinc-200 mb-3 font-medium">6. Transferencia de datos</h2>
            <p>Tus datos pueden ser compartidos con:</p>
            <ul className="list-disc pl-5 space-y-1 mt-2">
              <li>Stripe, Inc. para procesamiento de pagos.</li>
              <li>Autoridades mexicanas (SEMARNAT, PROFEPA) cuando sea legalmente requerido.</li>
              <li>Proveedores de servicios tecnológicos bajo acuerdos de confidencialidad.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg text-zinc-200 mb-3 font-medium">7. Retención de datos</h2>
            <p>Conservamos tus datos durante el tiempo que tu cuenta permanezca activa más un periodo adicional requerido por la legislación aplicable. Los datos de transacciones, evidencia de compliance y audit logs se conservan por un mínimo de 5 años conforme a obligaciones fiscales y legales.</p>
          </section>

          <section>
            <h2 className="text-lg text-zinc-200 mb-3 font-medium">8. Cookies y tecnologías de rastreo</h2>
            <p>Utilizamos cookies funcionales para mantener tu sesión activa y cookies analíticas para mejorar el servicio. El device fingerprint se utiliza exclusivamente para prevención de fraude.</p>
          </section>

          <section>
            <h2 className="text-lg text-zinc-200 mb-3 font-medium">9. Derechos ARCO</h2>
            <p>Conforme a la LFPDPPP, tienes derecho a:</p>
            <ul className="list-disc pl-5 space-y-1 mt-2">
              <li><strong className="text-zinc-300">Acceso:</strong> conocer qué datos personales tenemos.</li>
              <li><strong className="text-zinc-300">Rectificación:</strong> corregir datos inexactos o incompletos.</li>
              <li><strong className="text-zinc-300">Cancelación:</strong> solicitar la eliminación de tus datos.</li>
              <li><strong className="text-zinc-300">Oposición:</strong> oponerte al tratamiento para finalidades específicas.</li>
            </ul>
            <p className="mt-2">Para ejercer estos derechos, contacta a: <span className="text-zinc-300">privacidad@morphmx.com</span></p>
          </section>

          <section>
            <h2 className="text-lg text-zinc-200 mb-3 font-medium">10. Cambios al aviso</h2>
            <p>Nos reservamos el derecho de modificar este aviso. Los cambios serán notificados a través de la plataforma y entrarán en vigor inmediatamente tras su publicación.</p>
          </section>
        </div>
      </div>
    </div>
  );
}
